import { CONSULTANT_MANAGER_ROLES } from '@/common/constants/consultantRoles';
import { STATUSES_LABELS } from '@/common/constants/recruitmentStatuses';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useEffect, useState } from 'react';

const useRecruitmentSearchBar = ({ setVisibleCandidates, candidates }) => {
	const [selectedMarket, setSelectedMarket] = useState();
	const [selectedManager, setSelectedManager] = useState();
	const [selectedStatus, setSelectedStatus] = useState();

	const {
		options: { marketsOptions },
		filterUsersByRoles,
	} = useCommonDataContext();

	const managerOptions = [
		{ label: 'None', value: null },
		...filterUsersByRoles(CONSULTANT_MANAGER_ROLES),
	];

	const marketOptions = [{ label: 'None', value: null }, ...marketsOptions];
	const statusOptions = [{ label: 'None', value: null }, ...STATUSES_LABELS];

	const handleFilterMarket = (value) => {
		setSelectedMarket(value);
		setVisibleCandidates(
			candidates.filter(
				(candidate) =>
					(!value?.value || candidate.market === value.value) &&
					(!selectedManager?.value ||
						candidate.call_center_manager === selectedManager.value) &&
					(!selectedStatus?.value || candidate.status === selectedStatus.value),
			),
		);
	};

	const handleFilterManager = (value) => {
		setSelectedManager(value);
		setVisibleCandidates(
			candidates.filter(
				(candidate) =>
					(!selectedMarket?.value ||
						candidate.market === selectedMarket.value) &&
					(!value?.value || candidate.call_center_manager === value.value) &&
					(!selectedStatus?.value || candidate.status === selectedStatus.value),
			),
		);
	};

	const handleFilterStatus = (value) => {
		setSelectedStatus(value);
		setVisibleCandidates(
			candidates.filter(
				(candidate) =>
					(!selectedMarket?.value ||
						candidate.market === selectedMarket.value) &&
					(!selectedManager?.value ||
						candidate.call_center_manager === selectedManager.value) &&
					(!value?.value || candidate.status === value.value),
			),
		);
	};

	const handleDefaultFilter = () => {
		setVisibleCandidates(
			candidates.filter(
				(candidate) =>
					(!selectedMarket?.value ||
						candidate.market === selectedMarket.value) &&
					(!selectedManager?.value ||
						candidate.call_center_manager === selectedManager.value) &&
					(!selectedStatus?.value || candidate.status === selectedStatus.value),
			),
		);
	};

	useEffect(() => {
		handleDefaultFilter();
	}, [candidates]);

	return {
		filterUsersByRoles,
		selectedManager,
		handleFilterManager,
		marketsOptions,
		selectedMarket,
		handleFilterMarket,
		handleFilterStatus,
		selectedStatus,
		managerOptions,
		marketOptions,
		statusOptions,
	};
};

export default useRecruitmentSearchBar;
